import React, { useEffect, useContext, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  PseudoBox,
  SlideIn,
  Text,
  Flex,
  Box,
} from "@chakra-ui/core";
import useWindowSize from "hooks/useWindowSize";
import { ContextStore } from "context/ContextStore";
import wait from "utils/shared/wait";
import ShoppingBagOutline from "svg/icons/shopping-bag.svg";
import LocationMarkerOutline from "svg/icons/location-marker.svg";

const EatingPlaceModal = () => {
  const { ouvert, showToast, eatingPlace, setEatingPlace } = useContext(ContextStore);
  const [isEatingPlaceModalOpen, setEatingPlaceModalOpen] = useState(false);

  useEffect(() => {
    if (ouvert && eatingPlace && eatingPlace.changedAt) {
      const hoursDiff = Math.floor(Math.abs(new Date(eatingPlace.changedAt) - new Date()) / 36e5);
      console.log(hoursDiff);
      if (hoursDiff > 6) {
        wait(2000).then(() => {
          setEatingPlaceModalOpen(ouvert);
        });
      }
    }
  }, [eatingPlace, ouvert]);

  const windowSize = useWindowSize();

  // Saves eating place in local storage
  const handleSaveChoice = (choice) => {
    setEatingPlace({ value: choice, changedAt: new Date() });
    handleClose();
    wait(100).then(() => {
      showToast({ title: "Préférence enregistrée !" });
    });
  };

  // Closes the modal
  const handleClose = () => {
    setEatingPlaceModalOpen(false);
  };

  // Dynamically set the mobile height (100vh does not work well with the address bar)
  const mobileHeight = windowSize.height + "px";

  const choices = [
    { label: "À emporter", icon: ShoppingBagOutline, choiceKey: "aEmporter", disabled: false },
    { label: "Sur place", icon: LocationMarkerOutline, choiceKey: "surPlace", disabled: false },
  ];

  const ChoiceButton = ({ label, icon, disabled, onClick }) => {
    return (
      <PseudoBox
        p={6}
        border="2px"
        rounded="md"
        borderColor="gray.300"
        backgroundColor={disabled ? "gray.100" : "white"}
        transition="all 200ms ease"
        color="gray.500"
        w="full"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        cursor={!disabled && "pointer"}
        _hover={!disabled && { borderColor: "brand.400", backgroundColor: "brand.100", color: "brand.600" }}
        onClick={onClick}
      >
        <Box as={icon} size="40px" display="block" mb={2} />
        <Text fontSize="md" fontWeight={600}>
          {label}
        </Text>
      </PseudoBox>
    );
  };

  return (
    <>
      <SlideIn in={isEatingPlaceModalOpen}>
        {(styles) => (
          <Modal
            onClose={handleClose}
            closeOnOverlayClick={false}
            isOpen={true}
            size={{ base: "full", sm: "xl" }}
            isCentered
          >
            <ModalOverlay opacity={styles.opacity} />
            <ModalContent borderRadius="lg" {...styles} my={{ base: "0", sm: "2rem" }}>
              <ModalHeader textAlign="center" borderBottom="1px" borderColor="gray.100">
                Où souhaitez-vous manger ?
              </ModalHeader>
              <ModalCloseButton mt="2" />
              <ModalBody
                py="6"
                px="0"
                overflowY="auto"
                maxHeight={{
                  base: `calc(${mobileHeight} - 8.5rem)`,
                  sm: "calc(100vh - 12.5rem)",
                }}
              >
                <Flex
                  w="full"
                  align="center"
                  justify="center"
                  flexDirection={{ base: "column", sm: "row" }}
                  justify="center"
                  px={6}
                  pb={5}
                  style={{ gap: "20px" }}
                >
                  {choices.map((choice) => (
                    <ChoiceButton
                      key={choice.choiceKey}
                      icon={choice.icon}
                      label={choice.label}
                      onClick={() => handleSaveChoice(choice.choiceKey)}
                      disabled={choice.disabled}
                    />
                  ))}
                </Flex>
                <Text px={6} textAlign="center" fontSize="md" fontWeight={400} color="gray.400">
                  La livraison depuis notre site n'est pas encore disponible.
                </Text>
              </ModalBody>
            </ModalContent>
          </Modal>
        )}
      </SlideIn>
    </>
  );
};
export default EatingPlaceModal;
